<template>
	<div class="view-wrapper">
		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Society Info" class="mb-3">
				</b-card>

			</div>
		</div>

		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Factions" class="mb-3">
				</b-card>

			</div>
		</div>

		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Inventory Log">
				</b-card>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	
}
</script>

<style scoped>

</style>